var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 17.125C8.59961 17.125 9.5293 16.1953 9.5293 15H5.3125C5.3125 16.1953 6.24219 17.125 7.4375 17.125ZM14.5762 12.1777C13.9453 11.4805 12.7168 10.4512 12.7168 7.03125C12.7168 4.47461 10.9238 2.41602 8.4668 1.88477V1.1875C8.4668 0.623047 8.00195 0.125 7.4375 0.125C6.83984 0.125 6.375 0.623047 6.375 1.1875V1.88477C3.91797 2.41602 2.125 4.47461 2.125 7.03125C2.125 10.4512 0.896484 11.4805 0.265625 12.1777C0.0664062 12.377 -0.0332031 12.6426 0 12.875C0 13.4395 0.398438 13.9375 1.0625 13.9375H13.7793C14.4434 13.9375 14.8418 13.4395 14.875 12.875C14.875 12.6426 14.7754 12.377 14.5762 12.1777Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.e0cb9169254733de78dacb965e3f395d.svg";
export { ForwardRef as ReactComponent };